import { factory as popupFactory } from 'mewe/utils/popup-utils';
import { assert } from '@ember/debug';

export default function (params) {
  import('mewe/pods/components/dropdowns/targets-dropdown').then((Popup) => {
    assert('Context missing in lazy.js', params.ctx);
    popupFactory(params.ctx, Popup.default, 'targets-dropdown').create(params).send('open');
  });
}
